<template>
  <div class="hasPadding" @touchmove="preLoad(getRecord)">
    <default-page v-if="showDefaultPage"></default-page>

    <div
      v-else
      v-for="(item, index) in timeList"
      :key="index"
      class="timeBox vux-1px-b"
    >
      <p class="times">
        <span class="d"></span>
        <span>{{ item }}</span>
      </p>
      <div
        v-for="(item2, index2) in collectList[item]"
        :key="index2"
        class="recordBox"
        @click="jump(item2)"
      >
        <img :src="item2.coverPicUrl" class="record_banner" />
        <div class="recordWrapper">
          <p class="recordTitle">{{ item2.courseName }}</p>
          <p class="recordTime">已学习{{ item2.totalTime }}分钟</p>
        </div>
      </div>
    </div>
    <p
      style="text-align:center;margin-top: 1rem"
      v-show="!timeList.length && !showDefaultPage"
    >
      <inline-loading></inline-loading>
      <span style="vertical-align:middle;display:inline-block;font-size:14px;">
        &nbsp;&nbsp;加载中
      </span>
    </p>
  </div>
</template>
<script>
import ListForImgAndText from '@/components/Headline/list.vue';
import { personal } from '@/api/ajax.js';
// TODO: vux
import { dateFormat } from 'vux';
import { loadMore } from '@/Mixin/loadMore.js';
export default {
  name: '',
  mixins: [loadMore],
  data() {
    return {
      collectList: [],
      timeList: [],
      params: {
        pageNo: 1,
        pageSize: 20
      },
      loadFlag: true
    };
  },
  methods: {
    getRecord() {
      if (this.loadFlag) {
        this.loadFlag = false;
        personal
          .recordingLectures({
            pageNo: this.params.pageNo,
            pageSize: this.params.pageSize
          })
          .then(res => {
            let { list } = res.data.data;

            if (list.length < this.params.pageSize) {
              this.loadFlag = false;
            } else {
              this.loadFlag = true;
              this.params.pageNo += 1;
            }

            if (!list.length) {
              this.showDefaultPage = true;
            } else {
              this.showDefaultPage = false;
            }
            for (var i = 0; i < list.length; i++) {
              // list[i].time = dateFormat(new Date(list[i].lastReportDt), "YYYY-MM-DD")
              if (!this.collectList[list[i].lastReportDt]) {
                this.collectList[list[i].lastReportDt] = [];
                this.collectList[list[i].lastReportDt].push(list[i]);
              } else {
                this.collectList[list[i].lastReportDt].push(list[i]);
              }
            }
            this.timeList = Object.keys(this.collectList);
          });
      }
    },
    jump(item) {
      this.$router.push({
        name: 'courseDetail',
        params: { id: item.courseId }
      });
    }
  },
  computed: {},
  components: {
    ListForImgAndText
  },
  created() {
    this.getRecord();
  },
  mounted() {},
  filters: {
    today: function(val) {
      if (dateFormat(new Date(), 'YYYY-MM-DD') == val) {
        return '今天 ';
      } else {
        return val;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.times {
  font-size: 0.42rem;
  color: #191919;
  display: flex;
  align-items: center;
  margin-bottom: 0.467rem;
  .d {
    display: inline-block;
    width: 0.133rem;
    height: 0.133rem;
    background: #027cfa;
    border-radius: 50%;
    margin-right: 0.133rem;
  }
}
.timeBox {
  /*border-bottom: 1px solid #ebebeb;*/
  margin-top: 0.4rem;
  padding-bottom: 0.01rem;
}
.recordBox {
  display: flex;
  margin-bottom: 0.533rem;
  .record_banner {
    width: 2.667rem;
    height: 1.493rem;
    margin-right: 0.267rem;
    border-radius: 2px;
    -webkit-border-radius: 2px;
  }
  .recordWrapper {
    display: flex;
    flex-direction: column;
  }
  .recordTitle {
    font-size: 0.373rem;
    color: #191919;
    height: 1rem;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }
  .recordTime {
    font-size: 0.32rem;
    color: #999999;
    /*margin-top: .107rem*/
  }
}
</style>
